export const pendingPurchaseEnLocale = {
  'pending-purchase.title': 'Error in the Purchase Process',
  'pending-purchase.subtitle':
    'We have registered your payment correctly, but there was an inconvenience when finalizing the purchase.',
  'pending-purchase.contact': 'An advisor will contact you soon',
  'pending-purchase.contact-description':
    'Our team is reviewing your case and will contact you in the next 24 hours.',
  'pending-purchase.back': 'Back to Home',
  'pending-purchase.contactUs': 'Contact Us',
} as const;

export const pendingPurchaseEsLocale = {
  'pending-purchase.title': 'Error en el Proceso de Compra',
  'pending-purchase.subtitle':
    'Hemos registrado tu pago correctamente, pero hubo un inconveniente al finalizar la compra.',
  'pending-purchase.contact': 'Un asesor te contactará pronto',
  'pending-purchase.contact-description':
    'Nuestro equipo está revisando tu caso y te contactará en las próximas 24 horas.',
  'pending-purchase.back': 'Volver al Inicio',
  'pending-purchase.contactUs': 'Contáctanos',
} as const;
